import {createBrowserRouter} from "react-router-dom";
import PageFaq from "pages/Faq";
import Container from "./layout/Container";
import ROUTE from "./constants/route";
import {QuestionListProvider} from "pages/Faq/context/questionContext";
import MaterialContainer from "pages/Material/MaterialContainer";
import MaterialList from "pages/Material/list";
import MaterialView from "pages/Material/view";
import MaterialFirstView from "pages/Material/firstView";

const router = createBrowserRouter([
  {
    path: '/',
    element: <Container/>,
    children: [
      {
        path: ROUTE.QUESTIONS,
        element: (
          <QuestionListProvider>
            <PageFaq/>
          </QuestionListProvider>
        ),
      },
      {
        path: ROUTE.MATERIAL,
        element: <MaterialContainer/>,
        children: [
          {
            index: true,
            element: (
              <MaterialList/>
            )
          },
          {
            path: ':id/first',
            element: <MaterialFirstView />
          },
          {
            path: ':id',
            element: <MaterialView />
          }
        ]
      },
      {
        path: ROUTE.KNOWLEDGE_BASE,
        element: <MaterialContainer/>,
        children: [
          {
            index: true,
            element: (
              <MaterialList/>
            )
          },
          {
            path: ':id',
            element: <MaterialView />
          }
        ]
      }
    ]

  }
])

export default router;
